/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EStatusFilterType, EVehicleStatusType } from '../../models';
import { IMapOptionsState } from '../state';
import { getStatusFilterCounts } from './plots.selectors';
import { getGarminStopsPermissionAllowed, getIsCustomBalloonsFeatureEnabled } from './user-map-settings.selectors';

export const getMapOptions = createFeatureSelector<IMapOptionsState>('mapOptions');

export const getIsSuggestedGeofencesEnabled = createSelector(
  getMapOptions,
  (state: IMapOptionsState): boolean => state.isSuggestedGeofencesEnabled
);

export const getIsGeofencesEnabled = createSelector(getMapOptions, (state: IMapOptionsState): boolean => state.isGeofencesEnabled);

export const getIsGarminStopsEnabled = createSelector(getMapOptions, (state: IMapOptionsState): boolean => state.isGarminStopsEnabled);

export const getIsGarminStopsDisplayEnabled = createSelector(
  getGarminStopsPermissionAllowed,
  getIsGarminStopsEnabled,
  (isWorkingGarminStopsFeatureAllowed: boolean, isGarminStopsEnabled: boolean) => isWorkingGarminStopsFeatureAllowed && isGarminStopsEnabled
);

export const getIsWorkOrdersEnabled = createSelector(getMapOptions, (state: IMapOptionsState): boolean => state.isWorkOrdersEnabled);

export const getIsShowLabelsEnabled = createSelector(getMapOptions, (state: IMapOptionsState): boolean => state.isShowLabelsEnabled);

export const getVehicleStatusFilterType = createSelector(
  getMapOptions,
  getStatusFilterCounts,
  (state: IMapOptionsState, statusFilterCounts: Map<EStatusFilterType, number>): EStatusFilterType =>
    statusFilterCounts.has(state.vehicleStatusFilterType) ? state.vehicleStatusFilterType : EVehicleStatusType.All
);

export const getIsShowTachoInformationEnabled = createSelector(
  getMapOptions,
  (state: IMapOptionsState): boolean => state.isShowTachoInformationEnabled
);

export const getIsMapOptionsOpened = createSelector(getMapOptions, (state: IMapOptionsState): boolean => state.isMapOptionsOpened);

export const getShouldShowBalloonLinksOption = createSelector(
  getIsCustomBalloonsFeatureEnabled,
  (customBalloonFeature): boolean => !customBalloonFeature
);

export const getIsBalloonLinksEnabledFromMapOptions = createSelector(
  getMapOptions,
  (mapOptions: IMapOptionsState): boolean => mapOptions.isShowVehicleBalloonLinksEnabled
);
